import { render, staticRenderFns } from "./PanelDashboard.vue.js?vue&type=template&id=20c58166&scoped=true!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PanelDashboard.vue?vue&type=template&id=20c58166&scoped=true"
import script from "./PanelDashboard.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PanelDashboard.vue?vue&type=script&lang=js"
export * from "./PanelDashboard.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PanelDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c58166",
  null
  
)

export default component.exports